<template>
<modal name="parttime-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeDialog"
      icon="el-icon-close"
      type="text"></el-button>
  </div>
  <div style="display: inline-block;min-width: 100%;text-align:center;" >
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;">
        ダウンロードが完了しました！！！<br/>
        このまま新しい職場を探しましょう。
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;">
        <img src="/static/renew_img/mynabi_logo.png" style="width:100%" >
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 100%;">
        パスワードを入力して<br/>
        このまま新しい職場を探しましょう。
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 100%;text-align:center;"> ID（メールアドレス）：
              <el-input class="input-sm"
                placeholder=""
                title="メールアドレス"
                ref="email"
                v-model="inputEmail"
                type="email"></el-input></p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <br/>
      <p style="font-size: 100%;text-align:center;"> パスワード：
              <el-input class="input-sm"
                placeholder=""
                title="メールアドレス"
                v-model="inputPasswd"
                type="password"></el-input></p>
    </div>
    <br/>
    <br/>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link>
        <br/>
        ㈱アド・トップの<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報保護方針</a>、<a href="https://bit.ly/3bsyJ7E" target="_blank">詳細ページ</a>
      </p>
      <!-- <p>
        ㈱アイデムの<a href="https://jobrass.com/gakusei/SCST00503" target="_blank">利用規約</a>、<a href="https://www.aidem.co.jp/policy/index.html" target="_blank">個人情報保護方針</a>、<a href="https://jobrass.com/agent/" target="_blank">詳細ページ</a>
      </p> -->
    </div>
    <br/>
    <br/>
    <div class="text-center">
      <el-button :id="'pdf-'+$globalVar.dn_flag+'-rt-completed'" type="success" v-if="isSended == false" style="background-color:#0F9934;border-color:#0F9934;"
        @click="$eventHub.$emit('send-parttime-consult');">規約に同意して試しにサポートを受けてみる</el-button>
      <el-button :id="'pdf-'+$globalVar.dn_flag+'-rt-completed-done'" type="success" v-if="isSended == true"
        @click="closeDialog();">送信しました</el-button>
    </div>
    <br/>
    <div class="text-center">
      <el-button :id="'pdf-'+$globalVar.dn_flag+'-rt-completed-done'" v-if="isSended == false" type="primary" style="background-color:#999;border-color:#999;" @click="closeDialog();">サポートは受けない</el-button>
      <el-button :id="'pdf-'+$globalVar.dn_flag+'-rt-completed-done'" v-if="isSended == true" type="primary" style="background-color:#999;border-color:#999;" @click="closeDialog();">閉じる</el-button>
    </div>
    <br/>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      gradeYear: 0,
      permissionType: 1,
      isSended: false,
      fullscreenLoading: false,
      username: '',
      baite_title: 'バイト',
      isAgree: false,
      inputEmail: '',
      inputPasswd: '',
      foreignStudent: false,
      isRandom: true
    }
  },
  created: function () {
    console.error('parttime created')
    const app = this
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openParttimeDialog: function (id, html, email) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.inputEmail = this.$firebase.user.email
      if (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && this.inputEmail) {
        this.inputEmail = email
      }
      this.$modal.show('parttime-dialog')
      this.clearLocalStorageConfirmVisible = false
      const app = this
      this.$iterateStorage(function (value, key, iterationNumber) {
        // console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed')
        }
      })
    },
    closeDialog: function () {
      this.$modal.hide('parttime-dialog')
      this.clearLocalStorageConfirmVisible = false
      // this.$router.push('/mypage')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendRoxxConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      const app = this
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      if ((!this.$firebase.user.email && this.inputEmail) ||
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && this.inputEmail)) {
        formData.append('inputemail', this.inputEmail)
      }
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      this.$axios
        .post(this.$varuna.endPoints.sendDataRoxx, formData, { timeout: 60000 })
        .then(function (response) {
          // app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: '担当者からあなたのメールアドレスに連絡が届くことがあります！',
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 0,
            showClose: true,
            message: '応募に失敗しました。入力内容を確認して再度ご応募ください',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-parttime-consult', this.sendRoxxConsult)
    this.$eventHub.$on('open-parttime-dialog', this.openParttimeDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-parttime-consult', this.sendRoxxConsult)
    this.$eventHub.$off('open-parttime-dialog', this.openParttimeDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
